/**
 * Mostly used to send email to sales to upgrade plan
 *
 * @param subject: subject of the email
 */
export const contactSales = ({ subject }: { subject: string }) => {
  const email = 'sales@servicebell.com';
  const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  window.location.href = mailtoLink;
};
